import { useOrderQuery } from '@/hooks/queries/use-order-query';
import { OrderPaymentStatus } from '@/types/api/order/order-payment-status.enum';
import { useParams } from 'react-router-dom';
import { Loader } from '../ui/loader';

export default function Heading() {
  const { orderId } = useParams();
  const orderQuery = useOrderQuery(orderId!);

  if (orderQuery.error) throw orderQuery.error;

  if (orderQuery.isLoading) return <Loader />;

  return (
    <div className="flex flex-col items-center">
      {/* Icon */}
      <svg className="inline-flex w-16 h-16 fill-current mb-6" viewBox="0 0 64 64">
        <circle className="text-green-500/20" cx="32" cy="32" r="32" />
        <path
          className="text-green-700"
          d="M37.22 26.375a1 1 0 1 1 1.56 1.25l-8 10a1 1 0 0 1-1.487.082l-4-4a1 1 0 0 1 1.414-1.414l3.21 3.21 7.302-9.128Z"
        />
      </svg>
      {/* Title */}
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white sm:text-2xl mb-2">Tack för ditt stöd!</h2>

      <p className="text-gray-500 dark:text-gray-400 mb-6 md:mb-8 text-center">
        Vi skickar en orderbekräftelse på mejl. {orderQuery.data?.user?.firstName} tar kontakt med dig angående leverans
        {orderQuery.data?.paymentStatus !== OrderPaymentStatus.Paid && ' och betalning'}.
      </p>
    </div>
  );
}
